import React from 'react';
import { useAuth } from '../context/AuthContext';
import AuthPage from './AuthPage';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="app-loading-screen" role="status" aria-live="polite">
        <div className="app-loading-card">
          <div className="spinner-border" aria-hidden="true"></div>
          <div className="app-loading-text">Preparing your workspace...</div>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <>{children}</> : <AuthPage />;
};

export default PrivateRoute;
